import { helperText } from 'pages/tpm/constants';
import { Text } from 'components/v4';

const TpmCardHeaderContent = ({ title = 'Associate New Account' }) => (
    <>
        <Text className="text-xl font-semibold">{title}</Text>
        <p className="mt-[12px] text-xs font-medium leading-none tracking-tight text-[#8e8e8e]">
            {helperText}
        </p>
    </>
);

export default TpmCardHeaderContent;
